@if (railMenu; as entries) {
  <app-rail-menu
    [entries]="entries"
    [submenus]="{ 'new-item': newTaskForm, 'new-container': newProjectForm }"
    (selected)="runRailEntry($event)"
  />
  <ng-template #newTaskForm>
    <app-task-quick-form
      class="quick-form"
      [task]="railNewTask"
      [tenantItems]="railTenantItems"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
      (more)="handleQuickDetails($event)"
    />
  </ng-template>
  <ng-template #newProjectForm>
    <app-project-quick-form
      class="quick-form"
      [project]="railNewProject"
      [tenantItems]="railTenantItems"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
    (more)="handleQuickDetails($event)" />
  </ng-template>
} @else {
@if (sidebarFilterKey === 'following') {
  <app-context-menu-item title="Clear my subscriptions" [close]="true" (execute)="clearMySubscriptions()" />
}
@if ((isTeamRail && sidebarFilterKey === 'all_projects') || !(['all_projects', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
  <app-context-menu-item
    title="Add new task"
  [dismissGuard]="taskQuickForm.popoverDismissGuard"
    >
    <app-task-quick-form
    #taskQuickForm
      class="quick-form"
      [task]="stitchItem"
        [tenantItems]="[{ accountId: tenantId }]"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      (close)="handleClose()"
      (more)="handleQuickDetails($event)"
      />
    </app-context-menu-item>
  }

  @if ((isTeamRail && sidebarFilterKey === 'all_tasks') || !(['all_tasks', 'deleted', 'archived'] | includesBy: sidebarFilterKey)) {
    <app-context-menu-item
      title="Add new project"
      >
      <app-project-quick-form
        class="quick-form"
        [project]="containerStitchItem"
        [tenantItems]="[{ accountId: tenantId }]"
        [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
        (close)="handleClose()"
        (more)="handleQuickDetails($event)" />
      </app-context-menu-item>
    }

    @if (!(['all_tasks', 'deleted', 'archived', 'all_projects'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'flagged') {
      <app-context-menu-item
        title="Unflag all"
        [close]="true"
        (execute)="unFlagAll()"
        />
    }

    @if (sidebarFilterKey === 'followed') {
      <app-context-menu-item
        [title]="followUpWording.removeAllFollowUps()"
        [close]="true"
        (execute)="unFollowAll()"
        />
    }

    @if (sidebarFilterKey === 'snoozed') {
      <app-context-menu-item
        title="Unsnooze all"
        [close]="true"
        (execute)="unSnoozeAll()"
        />
    }

    @if ((['flagged', 'followed', 'snoozed'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-divider
        />
    }

    @if (sidebarFilterKey === 'archived') {
      <app-context-menu-item
        title="Delete all"
        [close]="true"
        (execute)="deleteAll()"
        />
    }

    @if (sidebarFilterKey === 'deleted') {
      <app-context-menu-item
        title="Empty trash"
        [disabled]="!(tenantId | appCanPurgeTeamItem)"
        [note]="PURGE_REFUSED_REASON"
        [matTooltip]="(tenantId | appCanPurgeTeamItem) ? '' : PURGE_REFUSED_REASON"
        [close]="true"
        (execute)="emptyTrash()"
        />
    }

    @if (rail) {
      <app-context-menu-item title="View settings…" [close]="true" (execute)="openRowViewSettings()" />
    } @else if (!(['deleted', 'archived'] | includesBy: sidebarFilterKey)) {
      <app-context-menu-item
        title="Settings"
        [close]="true"
        (execute)="openSettings()"
        />
    }
}
